<form
  [formGroup]="ssoForm" hidden="true" method="post"
  [action]="actionUrl" (ngSubmit)="submitForm()" #ssoFormTag>
  <input
    *ngFor="let input of formInputs"
    [formControlName]="input.key" [name]="input.key" type="text">
</form>
